import React, {useState} from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';

import SwitchButtons from './switchButtons';
import Sales from './sales';
import BuyList from './buy';
import Services from './services';
import Rents from './rents';
import {useNavigate} from 'react-router-dom';

const MyAdds = () => {
  const [choosedMyAd, setChoosedMyAd] = useState('sale');
  const navigate = useNavigate();

  return (
    <div className="flex w-full h-full flex-col justify-between">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="آگهی‌های من"
        isActiveRightIcon={true}
        onClick={() => navigate(`/my-account`)}
      />
      <SwitchButtons
        choosedMyAd={choosedMyAd}
        setChoosedMyAd={setChoosedMyAd}
      />
      <div className="flex w-full flex-col gap-3 h-full overflow-y-scroll px-3">
        {chosedList[choosedMyAd]}
      </div>

      <MainFooter />
    </div>
  );
};

export default MyAdds;

const chosedList: Record<string, JSX.Element> = {
  sale: <Sales />,
  rent: <Rents />,
  service: <Services />,
  buy: <BuyList />,
};
